import React from 'react';
import { Card, Paragraph } from '@mlc/web-ui-toolkit';
import { NoDataMessage } from './StaticContent';

const NoData = () => (
	<Card
		paddingTop={3}
		paddingBottom={3}
		margin={3}
		display="flex"
		alignItems="start"
		data-id="no-data-found"
		role="alert"
	>
		<Paragraph marginBottom={0}>{NoDataMessage}</Paragraph>
	</Card>
);

export default NoData;
